import * as React from 'react';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import { Theme, StyleRulesCallback, withStyles, WithStyles } from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';
import Account from '@material-ui/icons/AccountCircle';
import { connect } from 'react-redux';
import { actionCreators as loginActions } from '../login/loginStore'
import { localizations } from '../localization/localization';
import { push } from "react-router-redux";
import { bindActionCreators } from 'redux';
import { actionCreators as giveFeedbackActions } from '../feedback/store/giveFeedbackStore';
import { RouteName } from '../routeNames';
import * as termsHelpers from '../terms/termsHelpers';
import terms from '../register/privacy/Kayttoehdot-UnitSpotter_20180925.pdf'
import gdpr from '../register/privacy/Tietosuojaseloste-UnitSpotter.pdf'

const styles: StyleRulesCallback<Theme, object> = (theme: Theme) => ({
    link: {
        textDecoration: 'none',
        color: theme.palette.text.primary,
        '&:visited': {
            color: theme.palette.text.primary
        }
    }
});

interface UserMenuState {
    open: boolean;
    anchorEl: any
}

type UserMenuProps = WithStyles & { loginActions: typeof loginActions, goToActions: typeof goActions, feedbackActions: typeof giveFeedbackActions };

function openInNewTab(url: any) {
    const win = window.open(url, '_blank');
    if (win != null){
        win.focus();
    }
}

class UserMenu extends React.Component<UserMenuProps, UserMenuState> {

    constructor(props: UserMenuProps) {
        super(props);

        this.state = {
            open: false,
            anchorEl: null
        }

        this.handleClose = this.handleClose.bind(this);
        this.handleMenu = this.handleMenu.bind(this);
    }

    public render() {
        const { anchorEl } = this.state;
        const open = Boolean(anchorEl);
        const { classes } = this.props;

        return (
            <div>
                <IconButton
                    aria-haspopup="true"
                    onClick={this.handleMenu}
                    color="inherit"
                >
                    <Account />
                </IconButton>
                <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={open}
                    onClose={this.handleClose}
                >
                    <MenuItem onClick={() => {
                        this.props.goToActions.goTo(RouteName.Settings);
                        this.handleClose();
                    }}>{localizations.settings.settingsTitle}</MenuItem>
                    {/* <MenuItem onClick={() => {
                        this.props.feedbackActions.giveFeedback();
                        this.handleClose();
                    }}>{localizations.feedback.giveFeedback}</MenuItem> */}
                    <MenuItem onClick={() => {
                        termsHelpers.openHelp();                    
                        this.handleClose();
                    }}>{localizations.menus.instructions}</MenuItem>
                    <a href={terms} download className={classes.link} onClick={() => {
                        openInNewTab(RouteName.Terms);
                        this.handleClose();
                    }}>
                        <MenuItem>
                            {localizations.menus.termsOfService}
                        </MenuItem>
                    </a>
                    <a href={gdpr} download className={classes.link} onClick={() => {
                        openInNewTab(RouteName.Privacy);
                        this.handleClose();
                    }}>
                        <MenuItem>
                            {localizations.menus.privacyPolicy}
                        </MenuItem>
                    </a>
                    <Divider />
                    <MenuItem onClick={() => {
                        this.props.loginActions.changePassword();
                        this.handleClose();
                    }}>{localizations.login.changePassword}</MenuItem>
                    <Divider />
                    <MenuItem onClick={() => {
                        this.props.loginActions.logoutRequest();
                        this.handleClose();
                    }}>{localizations.actions.logout}</MenuItem>
                </Menu>
            </div>
        );
    }

    private handleMenu = (event: any) => {
        this.setState({ anchorEl: event.currentTarget });
    }

    private handleClose = () => {
        this.setState({ anchorEl: null });
    }
}

const goActions = {
    goTo: (location: string) => push(location)
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        loginActions: bindActionCreators(loginActions, dispatch),
        goToActions: bindActionCreators(goActions, dispatch),
        feedbackActions: bindActionCreators(giveFeedbackActions, dispatch)
    }
}

export default withStyles(styles)(connect<any, { goToActions: any, loginActions: any }, any>(null, mapDispatchToProps)(UserMenu));


// WEBPACK FOOTER //
// ./src/common/UserMenu.tsx